<template>
  <div class="CompanyIntro">
    <div class="company_top page_img">
      <div class="render">
        <p class="info1 font_shadow">中视觉健康科技（广州）有限责任公司</p>
        <p class="info2 font_shadow">VISION INTELLIGENT SYSTEM UNION MALL</p>
      </div>
      <img src="@/assets/img/intro_top.jpg" alt="">
    </div>
    <div class="map">
      <img class="back" src="@/assets/img/intro_map.jpg" alt="">
      <div class="render">
        <div class="map_summary font_shadow">VISUMALL介绍</div>
        <div v-for="item in list" class="title" :class="item.tag==1?'title1':''">
          <div class="dots" >
            <img v-if="item.tag==1" src="@/assets/img/intro_dot.png" alt="">
            <div v-else class="dots_dot"> </div>
          </div>
          {{item.title}}
        </div>
      </div>
    </div>

    <div class="serve">
      <div class="serve_summary font_shadow">智慧视光提供服务功能</div> 
      <div class="serve_content">
        <div class="serve_item" v-for="item in serveList">
          <img :src="item.src" alt="">
          <div class="serve_title">{{item.title}}</div>
          <div class="serve_info" v-for="item1 in item.info">{{item1}}</div>
        </div>
      </div>
      <div class="serve_footer">
        <div class="sum">VISUMALL智慧眼健康生态链</div>
        <div class="info">专业技术，专业运营，专业管理</div>
      </div>
    </div>

    <div class="page_system flex_column bserve" v-for="item in bserveList">
      <div class="sys_title">
        <div class="sys_summary font_shadow bserve_summary">{{item.summary}}</div>
      </div>
      <div class="sys_main flex_row bserve_item" v-for="item1 in item.item">
        <div class="sys_left flex_center item_left">
          <img :src="item1.src" alt="">
        </div>
        <div class="sys_right item_right">
          <div class="title bserve_title">{{item1.title}}</div>
          <div class="info" v-for="info in item1.info">{{info}}</div>
          <div class="tag bserve_tag" v-for="item1 in item1.tag"><span class="dots"></span>{{item1}}</div>
        </div>
      </div>
    </div>

    <div class="spread">
      <div class="spread_summary font_shadow">VISUMALL研发中心分布</div>
      <div class="spread_content">
        <img src="@/assets/img/intro_content.jpg" alt="">
      </div>
      <div class="page_decorate flex_row spread_footer">
        <div class="decorate_item flex_row spread_item" v-for="item in  spreadList">
          <div class="decorate_small_item flex_column item">
            <div class="spread_title">{{item.title}}</div>
            <div class="spread_info">{{item.info}}</div>
          </div>
          <div class="decorate_line flex_row spread_line">
            <span class="left"></span>
            <div class="line"></div>
            <span class="right"></span>
          </div>
        </div>
      </div>
    </div>

    <bottom></bottom>
  </div>
</template>

<script>
import bottom from "@/components/pc/bottom";
export default {
  name: 'CompanyIntro',
  components: {
    bottom
  },
  data() {
    return {
      list: [],
      serveList: [],
      bserveList: [],
      spreadList: [],
    }
  },
  created() {
    let list = [
      {
        title: "VISUMALL公司创始于2015年10月美国硅谷，医学研发中心落成于波士顿。",
        tag: 1
      },
      {
        title: "亚洲总部位于新加坡，成立于2016年5月",
        tag: 1
      },
      {
        title: "中国公司成立于2016年7月1日中国广州",
        tag: 1
      },
      {
        title: "VISUMALL是一家专注于为眼健康领域提供：人工智能诊疗服务技术及健康数据标准化的跨国高新技术企业",
        tag: 1
      },
      {
        title: "在医疗领域已获得各类专利和著作权近百项",
        tag: 2
      },
      {
        title: "公司通过联合全球专家资源，运用前沿医学眼科学和光学结合计算机应用技术和物联网推动医疗大健康领域的进步。",
        tag: 2
      },
      {
        title: "VISUMALL研发输出医学AI辅助诊断应用软件、检查、检测、体验式硬件和智能服务的医疗实体运营模式；",
        tag: 1
      },
      {
        title: "为消费者提供医疗健康服务和产品",
        tag: 2
      },
      {
        title: "为医生和医疗机构提供软硬件产品和方法工具",
        tag: 2
      },
      {
        title: "为医药产品厂家提供产业链信息化平台",
        tag: 2
      },
      {
        title: "为眼健康产业发展提供整体解决方案",
        tag: 2
      },
      // {
      //   title: "在全球眼科门诊视光中心机构用户10000间，患者处方数量每年8000万人次，眼视光专业技术用户：50000人",
      //   tag: 1
      // },
    ];
    this.list = list;
    let serveList = [
      {
        src: 'https://www.visumall.com/public/img/intro_serve1.png',
        title: '临床教学',
        info: ['眼科学','眼视光医学']
      },
      {
        src: 'https://www.visumall.com/public/img/intro_serve2.png',
        title: '技术应用',
        info: ['眼科检查','智能硬件','AI软件']
      },
      {
        src: 'https://www.visumall.com/public/img/intro_serve3.png',
        title: '门诊运营',
        info: ['互联网医院','远程诊疗物联网']
      },
      {
        src: 'https://www.visumall.com/public/img/intro_serve4.png',
        title: '智能系统',
        info: ['眼视光医疗管理','HIS/CRM/ERP']
      },
    ];
    let bserveList = [
      {
        summary: 'VISUMALL产品及服务',
        item: [
          {
            src: 'https://www.visumall.com/public/img/intro_bserve1.jpg',
            title: '软件业务',
            info: [],
            tag: ['眼科视光多病种AI分析诊断辅助系统','智慧视光门诊运营管理系统','云诊室远程诊疗系统','眼视光HIS,ERP,CRM系统']
          },
          {
            src: 'https://www.visumall.com/public/img/intro_bserve2.jpg',
            title: '硬件业务',
            info: [],
            tag: ['智慧视典配镜体验设备','3D配镜测量设备','人工智能诊断眼底筛查设备','眼科远程验光检查设备']
          },
          {
            src: 'https://www.visumall.com/public/img/intro_bserve3.jpg',
            title: '健康中心运营业务',
            info: [],
            tag: ['云诊室眼健康中心运营','眼视光门诊中心运营管理咨询','视光产品厂家战略咨询']
          }
        ]
      }
    ]
    let spreadList = [
      {
        title:'新英格兰视光学院',
        info:'创办于1894年波士顿',
      },
      {
        title:'洛杉矶光学中心',
        info:'人工智能研发中心',
      },
      {
        title:'波士顿医学中心',
        info:'眼视光临床研究中心',
      },
      {
        title:'VISUMALL中国区总部',
        info:'软硬件临床应用研究中心',
      },
    ]
    this.serveList = serveList;
    this.bserveList = bserveList;
    this.spreadList = spreadList;
  },
}
</script>

<style scoped lang="scss">
.CompanyIntro {
  .company_top {
    position: relative;
    .render {
      position: absolute;
      top: 65%;
      left: 7%;
      transform: translate(0, -50%);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .info1 {
        font-size: 0.22rem;
        font-weight: 400;
      }
      .info2 {
        margin-top: 0.1rem;
        font-weight: bold;
        font-size: 0.16rem;
      }
    }
  }

  .map {
    width: 100%;
    position: relative;
    .back {
      position: absolute;
      margin-top: 2rem;
      width: 100%;
      left: 50%;
      transform: translate(-50%,-5%);
      z-index: -1;
    }
    .render {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .map_summary {
        margin: 0.39rem 0;
        font-size: 0.25rem;
      }
      .title {
        width: 65%;
        display: flex;
        border-left: 0.02rem solid #ccc;
        padding-bottom: 0.3rem;
        text-align: left;
        font-size:  0.18rem;
        font-weight: 400;
        .dots {
          width: 0.26rem;
          height: 0.26rem;
          img {
            width: 0.26rem;
            height: 0.26rem;
            margin-left: -0.13rem;
            margin-top: -0.02px;
          }
          .dots_dot {
            margin-left: -0.08rem;
            margin-top: 0px;
            width: 0.16rem;
            height: 0.16rem;
            border-radius: 50%;
            background: #0B9BDA;
          }
        }
      }
      .title1 {
        font-weight: 600;
      }
      .title:last-child {
        padding-bottom: 0.6rem;
        border-left: 0.02rem solid transparent;
      }
    }
  }

  .serve {
    padding-bottom: 0.38rem;
    background: #e0f1f8;
    .serve_summary {
      padding: 0.32rem 0 0.5rem;
    }
    .serve_content {
      display: flex;
      justify-content: space-around;
      .serve_item {
        flex: 1;
        img {
          width: 90%;
        }
        .serve_title {
          margin: 0.3rem 0 0.15rem;
          font-size: 0.23rem;
          font-weight: bold;
        }
        .serve_info {
          margin-bottom: 0.08rem;
          font-size: 0.21rem;
          font-weight: 400;
          color: #226bff;
        }
      }
    }
    .serve_footer {
      margin-top: 0.8rem;
      .sum {
        font-size: 0.24rem;
      }
      .info {
        margin-top: 0.13rem;
        font-size: 0.29rem;
        font-weight: bold;
        color: #FE8300;
      }
    }
  }

  .bserve {
    margin-bottom: 0.87rem;
    .bserve_summary {
      margin: 0.5rem 0;
    }
    .bserve_item {
      margin: 0 0 0.58rem;
      .item_left {
        img{
          width: 75%;
        }
      }
      .item_right {
        text-align: left;
        .bserve_title {
          font-size: 0.24rem;
        }
        .bserve_tag {
          margin-top: 0.15rem;
          font-size: 0.19rem;
          .dots {
            margin: 0 0.05rem;
            width: 0.13rem;
            height: 0.13rem;
            border-radius: 50%;
            background-color: #999;

          }
        }
      }
    }
  }

  .spread {
    .spread_summary {
      background: #E0F2F9;
      padding: 0.35rem 0;
    }
    .spread_content {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .spread_footer {
      margin: 0.2rem 0 0.85rem;
      .spread_item {
        .item {
          border: 0.03rem solid #35ACE1;
          border-radius: 0.05rem;
          padding: 0.1rem 0.15rem;
          .spread_title {
            font-size: 0.17rem;
            font-weight: bold;
          }
          .spread_info {
            font-size: 0.14rem;
            margin-top: 0.16rem;
          }
        }
        .spread_line {
          span {
            width: 0.14rem;
            height: 0.14rem;
            border: 0.03rem solid #35ACE1;
            background: #FFFFFF;
          }
          .left {
            left: -0.11rem;
          }
          .right {
            right: -0.11rem;
          }
          .line {
            width: 13vw;
            height: 0.03rem;
            background: #1BA1DD;
          }
        }
      }
    }

  }
}
</style>
